import { Component } from '@angular/core';
import { ControlsModule } from 'segov-sigepo-lib'

@Component({
  selector: 'app-publicacao-de-materia',
  standalone: true,
  imports: [
    ControlsModule
  ],
  templateUrl: './publicacao-de-materia.component.html',
  styleUrl: './publicacao-de-materia.component.css'
})
export class PublicacaoDeMateriaComponent {
  goToSigepo(){
    window.open('https://diarioweb.mg.gov.br/newsys/src/interno/index.php/login_externos', "_blank");
  }
}
